<template>
  <div class="view login">
    <div class="container">
      <div class="title">{{ $t('loginTitle') }}</div>

      <div class="form-container">
        <input v-model="email" type="text" :placeholder="$t('emailAddress')" class="input" @keydown.enter="login" />
        <input v-model="password" type="password" :placeholder="$t('password')" class="input" @keydown.enter="login" />

        <div v-if="error" class="info">
          <div class="icon"></div>
          <div class="text">{{ errorMessage }}</div>
        </div>

        <div class="rememberme-container" @click="rememberMe = !rememberMe">
          <div class="checkbox" :class="{ checked: rememberMe }"></div>
          <div class="checkbox-label">{{ $t('rememberMe') }}</div>
        </div>
      </div>

      <div v-if="!loading" class="button main-button login-button" :class="{ disabled: !(email && password) }" @click="login">
        {{ $t('login') }}
      </div>
      <div v-else class="button main-button login-button">
        <div class="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="button link-button forgot-button" @click="$router.push('/forgetPassword')">
        {{ $t('forgotPassword?') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      password: '',
      rememberMe: false,
      loading: false,
      error: false,
      errorMessage: '',
    };
  },

  methods: {
    async login() {
      if (!this.email || !this.password) return;
      this.loading = true;
      // TODO: setup rememberMe
      const result = await this.$store.dispatch('login', {
        email: this.email,
        password: this.password,
        rememberMe: true,
      });
      if (result.status !== 200) {
        this.error = true;
        if (result.status === 401) {
          this.errorMessage = this.$t('loginFailed');
        } else if (result.status === 403) {
          this.errorMessage = this.$t('accountUnactive');
        } else if (result.status === 404) {
          this.errorMessage = this.$t('invalidCredentials');
        } else {
          this.errorMessage = this.$t('anErrorOccured');
        }
        this.loading = false;
      } else {
        this.loading = false;
        this.$router.push('/');
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.view {
  background: colors.$main-color;
  display: flex;
  align-items: center;
  justify-content: center;

  .container {
    max-width: calc(100% - 32px);
    width: 590px;
    height: auto;
    padding: 64px 96px;
    box-sizing: border-box;
    background: colors.$white-color;
    border-radius: 6px;
    box-shadow: 0 8px 24px rgba(colors.$darkblue-color, 0.2);

    @media screen and (max-width: 700px) {
      padding: 48px 32px;
    }

    .title {
      font-family: fonts.$title-font;
      color: colors.$darkblue-color;
      font-size: 24px;
      font-weight: 600;
      text-align: left;
      margin: 0 0 32px;
    }

    .form-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .input {
        width: 100%;
        height: 48px;
        margin: 0 0 16px;
        padding: 12px 16px;
        box-sizing: border-box;
        color: colors.$text-color;
        border: solid 1px colors.$lightgrey-color;
        border-radius: 4px;
        background: colors.$white-color;

        &:last-child {
          margin: 0;
        }

        &::placeholder {
          color: colors.$lightgrey-color;
        }
      }

      .rememberme-container {
        display: flex;
        align-items: center;
        width: 100%;
        margin: 0;
        cursor: pointer;

        .checkbox {
          margin-right: 8px;
        }
      }
    }

    .login-button {
      width: 0;
      margin: 32px auto;
    }

    .forgot-button {
      text-align: center;
      font-weight: 500;
      margin: 0 auto;
    }

    .info {
      margin: 0 0 12px;
      font-size: 14px;
      align-self: flex-start;
      display: flex;
      align-items: center;

      .icon {
        margin: 0 12px 0 0;
        position: relative;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 2px solid colors.$red-color;
        flex-shrink: 0;
        transform: scale(0.7);

        &:after {
          position: absolute;
          content: '';
          bottom: 3px;
          left: calc(50% - 1px);
          right: calc(50% - 1px);
          height: 8px;
          background: colors.$red-color;
        }

        &:before {
          position: absolute;
          content: '';
          top: 3px;
          left: calc(50% - 1px);
          right: calc(50% - 1px);
          height: 2px;
          background: colors.$red-color;
        }
      }

      .text {
        display: flex;
        align-items: center;
        color: colors.$red-color;
        font-size: 12px;
        opacity: 0.8;
        &.black {
          color: colors.$black-color;
          margin-bottom: 14px;
          font-weight: 500;
          font-size: 14px;
          line-height: 16px;
          display: flex;
          align-items: center;
          text-decoration-line: underline;
        }
      }
    }
  }
}
</style>
